import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.bidirectional,
}).default({});

const UtilityBase = z.object({
    type: z.literal('utility').default('utility'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const UtilityValidator = ComponentValidator.merge(UtilityBase);
export const UtilityPayloadValidator = ComponentPayloadValidator.merge(UtilityBase);

export const UtilityDefinition: ComponentDefinition = {
    type: 'utility',
    name: 'Utility',
    plural: 'Utilities',
    synonyms: ['Grid', 'Net'],
    indicator: 'GRID',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
        defaultVoltageType: 'AC',
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: UtilityValidator,
        payload: UtilityPayloadValidator,
    },
};

export type Utility = z.infer<typeof UtilityValidator>;
export type UtilityPayload = z.infer<typeof UtilityPayloadValidator>;
